module.exports = __webpack_public_path__ + "img/ttlilla.514baacc.jpg";